import { Action } from 'infra/types'
import { accountsAction } from 'state/new-summary/accounts/accounts.action'
import { IAccountsState } from './accounts.types'

const ACCOUNTS_INITIAL_STATE: IAccountsState = {
  loaders: {
    fetchingOverallSummary: false,
    downloadingOverallSummary: false,
    fetchingSpecificSummary: false
  },
  specificGroupSummaryTotal: {
    credit: 0,
    payment: 0
  },
  specificGroupSummaryDetails: undefined,
  overallStats: undefined,
  overallGroupStats: undefined,
  filter: undefined
}

export const AccountsSummaryReducer = (
  state: IAccountsState = ACCOUNTS_INITIAL_STATE,
  action: Action<any>
): IAccountsState => {
  switch (action.type) {
    case accountsAction.SET_SPECIFIC_GROUP_SUMMARY: {
      return {
        ...state,
        specificGroupSummaryTotal: action.payload
      }
    }
    case accountsAction.UN_SPECIFIC_ACCOUNTS_SUMMARY: {
      return {
        ...state,
        specificGroupSummaryDetails: undefined,
        specificGroupSummaryTotal: {
          credit: 0,
          payment: 0
        }
      }
    }
    case accountsAction.SET_SPECIFIC_GROUP_DETAILS: {
      return {
        ...state,
        specificGroupSummaryDetails: action.payload
      }
    }
    case accountsAction.SET_LOADERS: {
      return {
        ...state,
        [action.payload.loaderName]: action.payload.status
      }
    }
    case accountsAction.SET_OVERALL_STATS: {
      return {
        ...state,
        overallStats: action.payload
      }
    }
    case accountsAction.SET_OVERALL_GROUP_STATS: {
      return {
        ...state,
        overallGroupStats: action.payload
      }
    }
    case accountsAction.SET_ACCOUNTS_SUMMARY_FILTER: {
      return {
        ...state,
        filter: action.payload
      }
    }
    default: {
      return state
    }
  }
}
